import { QueryClient } from '@tanstack/react-query';

/**
 * Single app-wide TanStack Query client for `@smartsash/api-client` hooks (HS-847).
 *
 * `networkMode: 'always'` is deliberate. The default (`'online'`) *pauses* a query whenever the
 * browser is considered offline: the query sits at `status: 'pending'` + `fetchStatus: 'paused'`
 * with `error === null` and `isLoading === false`. Every page guard then falls through — the
 * loading branch does not fire because nothing is fetching, and the error branch does not fire
 * because there is no error — so the screen silently renders "no data" instead of the truth.
 * Observed live against the backend: a 403 on `/api/Log` left the Logs page showing an empty
 * table forever. With `'always'` the request runs, fails, and the error surfaces normally
 * (`errors.network` covers a genuine connectivity failure).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { networkMode: 'always' },
    mutations: { networkMode: 'always' },
  },
});
